import { gql } from '@apollo/client';

export default gql`
  query getMySuggestions {
    getMySuggestions {
      ok
      error
      data {
        _id
        branch
        title
        desc
        category
        priority
        status
        response
        responseDate
        responseBy
        employeeId
        employeeName
        employeeNameAr
        departmentId
        attachments {
          filename
          filetype
          url
          size
        }
        userId
        createdAt
        updatedAt
      }
    }
  }
`;
